module.exports = __webpack_public_path__ + "static/oluwaseun-b3d34cdd78eca5f4dc06fd5a4be647de.png";